import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  desc: Yup.string().required('Description is required'),
});
